<template>
  <span ref="trigger">
    <slot></slot>
    <transition :name="effect">
      <div ref="popover" v-if="show && popoverCondition" :class="['popover',placement]" :style="popoverStyle">
        <div class="arrow" :style="arrowStyle"></div>
        <h3 class="popover-title" v-if="title"><slot name="title">{{title}}</slot></h3>
        <div class="popover-content" v-if="content">
            <slot name="content">
                <span v-html="content"></span>
                <hr style="margin: 10px 0px 15px 0px;">
                <input-w v-model="dataModel" :validation="validation" @validateResult="checkValidateResult">
                    <!--<input type="text" :placeholder="placeholder" v-model="dataModel">-->
                    <textarea rows="4" cols="40" :placeholder="placeholder" v-model="dataModel" style="resize: none;"></textarea>
                </input-w>
            </slot>
        </div>
        <div>
            <button class="btn btn-danger btn-sm" style="float: left; margin: 5px" @click.prevent="cancel">{{$Jed.firstUpperTranslate('cancel')}}</button>
            <button class="btn btn-primary-default btn-sm" style="float: right; margin: 5px" @click.prevent="apply" :disabled="invalid">{{$Jed.firstUpperTranslate('ok')}}</button>
        </div>  
      </div>
    </transition>
  </span>
</template>

<script>
import PopoverMixin from './utils/popoverMixins.js'
import InputW from '../inputWrapper/inputWrapper.vue'
import { eventBus } from "../../../eventbus";

export default {
  mixins: [PopoverMixin],
  props: {
    trigger: {
        type: String, 
        default: 'click'
    },
    popoverStyle: {type: Object},
    arrowStyle: {type: Object},
    title: String,
    content: String,
    value: String,
    validation: String,
    placeholder: String
  },
  components: {
    InputW
  },
  data: function(){
      return {
          popoverCondition: true,
          dataModel: null,
          invalid: true
      }
  },
  mounted: function(){
      this.dataModel = this.value;
  },
  watch: {
      value: function(){
          this.dataModel = this.value;
      },
      dataModel: function(){
          this.invalid = true;
      }
  },
  methods: {
      close: function(){
          this.dataModel = null;
          this.toggle();
      },
      cancel: function(){
          this.toggle();
      },
      apply: function(){
          this.$emit("confirm", this.dataModel);
          this.close();
      },
      checkValidateResult: function($event){
          this.invalid = !$event.result;
      }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/dynamic/popoverWrapper/TextModifier.vue?00eba17b